import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PaymentgetwayService } from '..';
import { environment } from '../../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class PaymentOffersService {
    baseUrlFlight = environment.flightConfig.apiUrl;
    PG_OFFERS: any = null;
    finalOfferList;
    pgOfferValid: boolean;

    constructor(private http: HttpService, private dataPayment: PaymentgetwayService) { }

    getPGOffers(pg_id: number, amount: string): Observable<any> {
        if (this.PG_OFFERS) {
            return of(this.PG_OFFERS);
        }
        const PG_OFFERS_BODY = { pg_id, amount };
        return this.http.flightget(`apiV2/payment/pg-offers`, PG_OFFERS_BODY).pipe(
            map(res => {
                if (res.statusCode === 200) {
                    const now = new Date();
                    let allOffers: any[] = [];
                    (res.data || []).forEach(offer => {
                    if (offer.key) {
                        // offer.is_all_payment_methods_available = false;
                        // if (offer.is_all_payment_methods_available === true) {
                        //     offer.supported_payment_methods = null;
                        // }
                        // const originalSPM = offer.supported_payment_methods
                        //     ? JSON.parse(JSON.stringify(offer.supported_payment_methods))
                        //     : null;
                        // const offerMinus1 = {
                        //     ...offer,
                        //     key: offer.key + '-1',
                        //     discount: 50,
                        //     supported_payment_methods: originalSPM ? JSON.parse(JSON.stringify(originalSPM)) : null
                        // };
                        // const offerMinus2 = {
                        //     ...offer,
                        //     key: offer.key + '-2',
                        //     discount: 500,
                        //     supported_payment_methods: originalSPM ? JSON.parse(JSON.stringify(originalSPM)) : null
                        // };
                        // if (originalSPM && originalSPM[7]) {
                        //     delete originalSPM[7];
                        // }
                        // offer.supported_payment_methods = originalSPM;
                        // allOffers.push(offer, offerMinus1, offerMinus2);
                        allOffers.push(offer);
                    } else {
                    allOffers.push(offer);
                }
            });
            const PG_OFFERS = allOffers.filter(offer => {
                const from = new Date(offer.valid_from);
                const to = new Date(offer.valid_to);
                const isDiscountValid = offer.discount !== null; // =!== null
                const isDateValid = now >= from && now <= to;
                return isDateValid; // isDiscountValid && 
            });
            // Optional: assign for caching
            this.PG_OFFERS = PG_OFFERS;
            // console.log('✅ Final PG Offers:', PG_OFFERS);
            return PG_OFFERS;
            } else {
                throw new Error('Failed to fetch PG Offers');
            }
        }),
        catchError(err => {
            return of([{
                IsError: true,
                errMessage: err?.error?.data,
            }]);
        }));
    }

    VALIDATE_UPI_HANDLE(upiId: string, methods: any[]): any | null {
        const h = upiId?.split('@')[1]?.toLowerCase();
        return h && Array.isArray(methods?.[7])
            ? methods[7].find((m: any) => m.handle?.some((x: string) => x.toLowerCase() === h)) || null
            : null;
    }

    async VALIDATE_CREDIT_HANDLE(cardValue: string, methods: any, PAYMENT_SUMMARY: any): Promise<boolean>  {
        const cleanCardValue = cardValue.replace(/\s+/g, '');
        const isValid = cleanCardValue.length > 15 && methods?.key;
        if (isValid) {
            const OFFER_BODY = {
                amount: PAYMENT_SUMMARY?.SUMMARY?.pay_total_amount,
                offer_key: PAYMENT_SUMMARY?.OFFER_KEY,
                payment_category_id: this.dataPayment?.CreditCard?.credit_value_payOption,
                card_number: cleanCardValue,
                payment_code: methods.key,
                pg_id: PAYMENT_SUMMARY?.PG_ID
            };
            return await this.CHECK_OFFER_VALID___(OFFER_BODY);
        }
        return false;
    }

    async VALIDATE_DEBIT_HANDLE(cardValue: string, methods: any, PAYMENT_SUMMARY: any): Promise<boolean>  {
        const cleanCardValue = cardValue.replace(/\s+/g, '');
        const isValid = cleanCardValue.length > 15 && methods?.key;
        if (isValid) {
            const OFFER_BODY = {
                amount: PAYMENT_SUMMARY?.SUMMARY?.pay_total_amount,
                offer_key: PAYMENT_SUMMARY?.OFFER_KEY,
                payment_category_id: this.dataPayment?.DebitCard?.debit_value_payOption,
                card_number: cleanCardValue,
                payment_code: methods.key,
                pg_id: PAYMENT_SUMMARY?.PG_ID
            };
            return await this.CHECK_OFFER_VALID___(OFFER_BODY);
        }
        return false;
    }

    VALIDATE_INTERNET_HANDLE(net_bankingValue: any, methods: any[]): boolean {
        if (!net_bankingValue?.code || !Array.isArray(methods)) return false;
        return methods.find(method => method.key === net_bankingValue.code) || null;
    }


    CHECK_OFFER_VALID___(OFFER_BODY: any): Promise<boolean> {
        const body = OFFER_BODY;
        return new Promise((resolve) => {
            this.http.flightsave(`apiV2/payment/pg-offer-validation`, body).subscribe({
                next: (res: any) => resolve(res.statusCode === 200),
                error: () => resolve(false)
            });
        });
    }

    getPGOffersIDFlight(): number {
        if (this.PG_OFFERS) {
            return environment.flightConfig.apiUrl === 'dev' ? 1 : 2;
        }
        return 2;
    }

    getPgOfferAllow() {
        return this.baseUrlFlight !== 'dev.belairtrip.com';
        // return true;
    }
}
